import { Routes, Route } from "react-router-dom";
import Protected from "./Protected";

import AdminCustomers from "../qcr-admin/Customers/Customers";
import ArchivedCustomers from "../qcr-admin/Customers/ArchivedCustomers";
import AdminDashboard from "../qcr-admin/Dashboard/Dashboard";
import AdminInvestigators from "../qcr-admin/Investigators/Investigators";
import AdminNotifications from "../qcr-admin/Notifications/AdminNotifications";
import OrderDetail from "../qcr-admin/Orders/OrderDetail";
import AdminOrders from "../qcr-admin/Orders/Orders";
import AssignInvestigator from "../qcr-admin/Orders/AssignInvestigator";
import EditOrder from "../qcr-admin/Orders/EditOrder";
import AdminReports from "../qcr-admin/Reports/Reports";
import ReportTemplates from "../qcr-admin/Template/ReportTemplates";
import FormTemplates from "../qcr-admin/Template/FormTemplates";
import CustomerViewDetails from "../qcr-admin/Customers/CustomerViewDetails";
import AddNewCustomer from "../qcr-admin/Customers/AddNewCustomer";

import Dashboard from "../qcr-customer/Dashboard/Dashboard";
import Forms from "../qcr-customer/Forms/Forms";
import ApplicationWebform from "../qcr-customer/Forms/ApplicationWebform";
import SubmitOrder from "../qcr-customer/Forms/SubmitOrder";
import CreditApplicationForm from "../qcr-customer/Forms/CreditApplicationForm";
import Invoices from "../qcr-customer/Invoices/Invoices";
import Notifications from "../qcr-customer/Notifications/Notifications";
import Orders from "../qcr-customer/Orders/Orders";
import OrdersDetails from "../qcr-customer/Orders/OrdersDetails";
import Reference from "../qcr-customer/Reference/Reference";
import Reports from "../qcr-customer/Reports/Reports";
import ReportsView from "../qcr-customer/Reports/ReportsView";
import ThankYou from "../components/ThankYou/ThankYou";
import Notfound from "../components/Notfound/Notfound";

import InvestigatorDashboard from "../qcr-investigator/Dashboard/Dashboard";
import InvestigatorOrders from "../qcr-investigator/Orders/Orders";
import InvestigatorOrderDetails from "../qcr-investigator/Orders/OrderDetails";
import InvestigatorReports from "../qcr-investigator/Reports/Reports";
import InvestigatorNotifications from "../qcr-investigator/Notifications/Notifications"; 

import QADashboard from "../qcr-qa/Dashboard/Dashboard";
import QAOrders from "../qcr-qa/Orders/Orders";
import QAOrderDetails from "../qcr-qa/Orders/OrderDetails";
import QAReports from "../qcr-qa/Reports/Reports";
import QANotifications from "../qcr-qa/Notifications/Notifications";

import HistoricalReports from "../qcr-common/HistoricalReport";


export function AdminRoutes() {
  return (
    <Routes>
      <Route>
        <Route path="*" element={<Notfound />} />
        <Route exact path="Dashboard" element={<Protected><AdminDashboard /></Protected>} />
        <Route exact path="Orders" element={<Protected><AdminOrders /></Protected>} />
        <Route exact path="Customers" element={<Protected><AdminCustomers /></Protected>} />
        <Route exact path="ArchivedCustomers" element={<Protected><ArchivedCustomers /></Protected>} />
        <Route exact path="Investigators" element={<Protected><AdminInvestigators /></Protected>} />
        <Route exact path="Reports" element={<Protected><AdminReports /></Protected>} />
        <Route exact path="Template" element={<Protected></Protected>} />
        <Route exact path="ReportTemplates" element={<Protected><ReportTemplates /></Protected>} />
        <Route exact path="FormTemplates" element={<Protected><FormTemplates /></Protected>} />
        <Route exact path="OrderDetail" element={<Protected><OrderDetail /></Protected>} />
        <Route exact path="AssignInvestigator" element={<Protected><AssignInvestigator /></Protected>} />
        <Route exact path="EditOrder" element={<Protected><EditOrder /></Protected>} />
        <Route exact path="AdminNotifications" element={<Protected><AdminNotifications /></Protected>} />
        <Route exact path="CustomerViewDetails" element={<Protected><CustomerViewDetails /></Protected>} />
        <Route exact path="AddNewCustomer" element={<Protected><AddNewCustomer /></Protected>} />
      </Route>
    </Routes>
  );
  }

export function CustomerRoutes() {
  return (
    <Routes>
      <Route>
        <Route path="*" element={<Notfound />} />
        <Route exact path="Dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route exact path="Orders" element={<Protected><Orders /></Protected>} />
        <Route exact path="OrdersDetails" element={<Protected><OrdersDetails /></Protected>} />
        <Route exact path="Forms" element={<Protected><Forms /></Protected>} />
        <Route exact path="Reports" element={<Protected><Reports /></Protected>} />
        <Route exact path="ReportsView" element={<Protected><ReportsView /></Protected>} />
        <Route exact path="Invoices" element={<Protected><Invoices /></Protected>} />
        <Route exact path="Reference" element={<Protected><Reference /></Protected>} />
        <Route exact path="Notifications" element={<Protected><Notifications /></Protected>} />
        <Route exact path="ApplicationWebform" element={<Protected><ApplicationWebform /></Protected>} />
        <Route exact path="SubmitOrder" element={<Protected><SubmitOrder /></Protected>} />
        <Route exact path="CreditApplicationForm" element={<Protected><CreditApplicationForm /></Protected>} />
        <Route exact path="ThankYou" element={<Protected><ThankYou /></Protected>} />
        <Route exact path="HistoricalReport" element={<Protected><HistoricalReports /></Protected>} />
      </Route>
    </Routes>
  );
}
export function InvestigatorRoutes() {
  return (
    <Routes>
      <Route>
        <Route path="*" element={<Notfound />} />
        <Route exact path="Dashboard" element={<Protected><InvestigatorDashboard /></Protected>} />
        <Route exact path="Orders" element={<Protected><InvestigatorOrders /></Protected>} />
        <Route exact path="OrderDetails" element={<Protected><InvestigatorOrderDetails /></Protected>} />  
        <Route exact path="Reports" element={<Protected><InvestigatorReports /></Protected>} />  
        <Route exact path="Notifications" element={<Protected><InvestigatorNotifications /></Protected>} /> 
      </Route>
    </Routes>
  );
}
export function QARoutes() {
  return (
    <Routes>
      <Route>
        <Route path="*" element={<Notfound />} />
        <Route exact path="Dashboard" element={<Protected><QADashboard /></Protected>} />
        <Route exact path="Orders" element={<Protected><QAOrders /></Protected>} />
        <Route exact path="OrderDetails" element={<Protected><QAOrderDetails /></Protected>} />  
        <Route exact path="Reports" element={<Protected><QAReports /></Protected>} />  
        <Route exact path="Notifications" element={<Protected><QANotifications /></Protected>} /> 
      </Route>
    </Routes>
  );
}
